import * as React from "react";
import * as S from "@styled";
import { IProcessData } from "../processEditor/model/IProcessData";
import { ProcessVersionDetails } from "../processList/model/ProcessVersion";
import { DiffSide } from "./BpmnDiffer";
import { handleToggleDropdown } from "shared/styles/helpers";
import { ClickEvent } from "shared/model/Event";
import DropdownButton from "shared/components/DropdownButton";

export const DiffVersionHeader: React.FC<VersionHeaderProps> = (props) => {

    const onSelectDropDownItem = (e: ClickEvent<HTMLAnchorElement>, newVersion: number) => {
        // Prevent default <a> event. Middle mouse click will open in new tab.
        e.preventDefault();
        props.onVersionChanged(newVersion);
    };

    const versionRefName = `process-diff-${props.side}`;

    const currentProcessVersion = props.processVersionsToShow?.find((f) => f.version === props.process?.version);

    return (
        <S.DiffHeader className={props.side}>
            <S.DiffProcessName>
                {props.process?.name}
            </S.DiffProcessName>
            <DropdownButton
                id={versionRefName}
                buttonComponent={(
                    <S.Button type="button" className="dropbtn" id={versionRefName + "-dropdown"} title={`v.${props.process?.majorVersion}.${props.process?.minorVersion}.${props.process?.version}`} onClick={() => handleToggleDropdown(versionRefName)}>
                        {currentProcessVersion?.majorVersion}.{currentProcessVersion?.minorVersion}.{currentProcessVersion?.version}
                    </S.Button>
                )}
            >
                {props.processVersionsToShow?.map((version) => (
                    <a
                        onClick={(e) => onSelectDropDownItem(e, version.version)}
                        key={version.version + props.side}
                        href={`${props.baseUri}${version.version}`}
                    >
                        {version.majorVersion}.{version.minorVersion}.{version.version}
                        {version.deployedToAgentGroups && version.deployedToAgentGroups.length ? <span>&nbsp;({version.deployedToAgentGroups.join(",")})</span> : null}
                    </a>
                ))}
            </DropdownButton>
        </S.DiffHeader>
    );
};

interface VersionHeaderProps {
    process: IProcessData | null;
    side: DiffSide;
    baseUri: string | null;
    processVersionsToShow: ProcessVersionDetails[] | null | undefined;
    pullRight: boolean;
    onVersionChanged: (left: any) => void;
}
